module.exports = __webpack_public_path__ + "img/logo-W3P.2cd7e177.svg";